const riot = require('riot');
riot.tag2('segment', '<div class="card is-collapse"> <header class="card-header"> <p class="card-header-title {has-text-grey:!expanded}" onclick="{toggleExpanded}"> {profile.name} ({profile._id}) </p> <p class="card-header-icon"> <button if="{expanded && !isAutomated}" class="button is-small" onclick="{removeSegment}">Remove segment</button> &nbsp;&nbsp; <button if="{(expanded || segment.isDefault)}" class="button is-small {is-primary:segment.isDefault}" onclick="{setDefault}"> <virtual if="{!segment.isDefault}">set </virtual>default </button> &nbsp;&nbsp; <button if="{segment.pinned && !pin_disabled}" class="button is-small is-info" onclick="return false"> pinned: {segment.pinned_posts} </button> &nbsp;&nbsp; <button if="{segment.exclusive && !pin_disabled}" class="button is-small is-info" onclick="return false"> exclusive </button> &nbsp;&nbsp; <a href="#" onclick="{toggleExpanded}" aria-label="more options"> <span class="icon"> <i class="fas {fa-angle-down:!expanded,fa-angle-up:expanded}" aria-hidden="true"></i> </span> </a> </p> </header> <div if="{expanded}" class="card-content has-background-white-bis" style="margin-bottom:1em"> <div class="field columns"> <div class="column field is-grouped"> <div class="field control"> <label for="name" class="label">Keyword</label> <input class="input is-small" readonly type="text" riot-value="{profile.keyword}" name="keyword" ref="keyword"> </div> </div> <div if="{!segment.isDefault && !pin_disabled}" class="column field is-grouped"> <div class="field control"> <label for="pinned_{profile._id}" class="label">Pinned</label> <input type="checkbox" name="pinned_{profile._id}" onchange="{setPinned}" id="pinned_{profile._id}" ref="pinned" class="switch is-info" checked="{segment.pinned}"> <label for="pinned_{profile._id}">&nbsp;</label> </div> <div class="field control" if="{segment.pinned}"> <label for="pinned_posts_{profile._id}" class="label">Pinned posts (max)</label> <input type="text" name="pinned_posts_{profile._id}" onchange="{setPinnedPosts}" id="pinned_posts_{profile._id}" ref="pinned_posts" class="input is-small" riot-value="{segment.pinned_posts}" placeholder="max number of pinned posts"> </div> </div> <div if="{!segment.isDefault && !pin_disabled}" class="column field"> <div class="field control"> <label for="exclusive_{profile._id}" class="label">Exclusive</label> <input type="checkbox" name="exclusive_{profile._id}" onchange="{setExclusive}" id="exclusive_{profile._id}" ref="exclusive" class="switch is-info" checked="{segment.exclusive}"> <label for="exclusive_{profile._id}">&nbsp;</label> </div> </div> </div> <div class="field xcolumns"> <div class="is-grow"> <label class="label">Target Group</label> <input class="input is-small" name="filter" ref="filter" riot-value="{profile.filter}"> <input class="input is-small" name="iab_filter" ref="iab_filter" riot-value="{profile.iab_filter}"> </div> </div> <div if="{!isAutomated}" class="columns"> <div class="column"> <label class="label">Goals &nbsp;&nbsp;&nbsp;</label> <div class="field is-grouped"> <div class="control"> <div class="select is-small"> <select name="goal_mode" ref="goal_mode" onchange="{setGoalMode}"> <option each="{goal_modes}" riot-value="{id}" selected="{segment.goal_limit.mode == id}">{mode}</option> </select> </div> </div> <div if="{segment.goal_limit.mode != \'disable\'}" class="control"> <input name="goal_limit" ref="goal_limit" riot-value="{segment.goal_limit.limit}" onchange="{setGoalLimit}" type="{\'number\'}"> </div> </div> </div> </div> <div if="{!isAutomated}" class="columns"> <div class="column"> <div class="control field is-grouped"> <label class="label">Time Limits &nbsp;&nbsp;&nbsp;</label> <div class="select is-small"> <select name="time_limit_mode" ref="time_limit_mode" onchange="{setTimeLimitMode}"> <option each="{time_limit_modes}" riot-value="{id}" selected="{segment.time_limit.mode == id}">{mode}</option> </select> </div> </div> <div if="{segment.time_limit.mode != \'disable\'}" class="control time_limit" each="{day in time_limit_days}"> <div class="field is-grouped"> <label>{day.name}</label> <button class="button is-small {is-info:(time_limit_intervals[day.id] && time_limit_intervals[day.id][hour])}" onclick="{toggleTimeLimit(day.id,hour)}" each="{hour in time_limit_hours}">{hour}</button> </div> </div> </div> </div> <div if="{!isAutomated}" class="columns"> <div class="column drop-area" ondrop="{drop(\'deselect\')}" ondragover="{markDrop}"> <div class="control"> <label class="label">Content to show</label> </div> <div class="field is-grouped"> <div class="control"> <div class="select is-small"> <select name="postStatus" ref="postStatus" onchange="{setPostStatusFilter}"> <option value="notrash" selected="{post_filter==\'notrash\'}">not trash</option> <option value="published" selected="{post_filter==\'published\'}">published</option> <option value="draft" selected="{post_filter==\'draft\'}">draft</option> </select> </div> </div> <div class="control"> <div class="select is-small"> <select name="postCategory" ref="postCategory" onchange="{setPostCategoryFilter}"> <option value="all" selected="{segment.category==\'all\'}">all cats</option> <option each="{cat in post_categories}" riot-value="{cat}" selected="{cat==segment.category}">{cat}</option> </select> </div> </div> <div class="control"> <div class="select is-small"> <select name="postTag" ref="postTag" onchange="{setPostTagFilter}"> <option value="all" selected="{segment.tag==\'all\'}">all tags</option> <option each="{tag in post_tags}" riot-value="{tag._id}" selected="{tag._id==segment.tag}">{tag._id}</option> </select> </div> </div> </div> <div class="field control"> <input class="input is-small" name="manual_query" ref="manual_query" onchange="{setManualQuery}" riot-value="{segment.manual_query}" placeholder="JSON query to be combined to mongo"> </div> <div each="{post in available_posts}" class="media" draggable="true" ondragstart="{drag}"> <div class="media-content"> <img riot-src="https://images4.contentexchange.me/fit/magic/?size=64x64&url={post.image}" style="float:left;margin-right:10px"> <p class="title is-6 "> <a href="{post.url}" class="{has-text-danger:post.status != \'published\' ,has-text-grey-dark:post.status == \'published\'}" target="_blank">{post.name}</a>&nbsp;<span class="icon has-text-grey-light"><i class="fas fa-external-link-alt" aria-hidden="true"></i></span> </p> <p class="subtitle is-6"> <small> CTR: {(100*post.stat.ctr).toFixed(2)}% ({post.stat.clicks} / {post.stat.impressions})</small> <small> PRICE: {post.price}</small> <small> ORDER: {post.order && post.order[name]}</small> </p> </div> <div class="media-right flex-shrink"> <input class="input is-small" value="0" onchange="{selectInOrder}"> </div> </div> </div> <div class="column drop-area" ondrop="{drop(\'select\')}" ondragover="{markDrop}"> <div class="control"> <label class="label">Selected content</label> </div> <div class="field is-grouped"> <div class="control"> <div class="select is-small"> <select name="fixed_mode" ref="fixed_mode" onchange="{setMode}"> <option value="">Selection mode</option> <option each="{fixed_modes}" riot-value="{id}" selected="{segment.fixed_mode == id}">{mode}</option> </select> </div> </div> <div class="control"> <button class="button is-small" onclick="{exportPosts}">Copy</button> <button class="button is-small" onclick="{importPosts}">Paste</button> </div> </div> <div each="{post, id in selected_posts}" class="media drop-area" draggable="true" ondragstart="{drag}" ondrop="{drop(\'before\')}" ondragover="{markDrop}"> <div class="media-content"> <p class="title is-6 "> <a href="{post.url}" class="{has-text-danger:post.status != \'published\' ,has-text-grey-dark:status == \'published\'}" target="_blank">{post.name}</a>&nbsp;<span class="icon has-text-grey-light"><i class="fas fa-external-link-alt" aria-hidden="true"></i></span> </p> <p class="subtitle is-6"> <small> {(100*post.stat.ctr).toFixed(2)}% ({post.stat.clicks} / {post.stat.impressions})</small> <small> {post.price}</small> <small> ORDER: {post.order[name]}</small> </p> </div> <div class="media-right flex-shrink"> <input class="input is-small" riot-value="{id + 1}" onchange="{setOrder}"> </div> </div> </div> </div> </div> </div>', '', '', function(opts) {

		const self = this;

		self.expanded =  self.parent.expanded_segment == self.segment.profile_id;
		self.isAutomated = self.parent.isAutomated;
		self.time_limit_intervals = {};
		self.posts = [];
		self.post_filter = 'published';
		self.post_categories = [];
		self.available_posts = [];
		self.selected_posts = [];
		self.dragged_post = null;
		self.drop_location = null;
		self.sites = self.parent.sites || self.parent.parent.parent.sites || []
		self.site = self.parent.parent.site || null
		self.pin_disabled = self.parent.widget && self.parent.widget.retarget_enable

		{
			self.goal_modes = [{
				id: 'disable',
				mode: 'Disabled'
			}, {
				id: 'impression',
				mode: 'Impressions'
			}, {
				id: 'click',
				mode: 'Clicks'
			}, {
				id: 'conversions',
				mode: 'Conversions'
			}];
			self.time_limit_modes = [{
				id: 'disable',
				mode: 'Disabled'
			}, {
				id: 'include',
				mode: 'Any of'
			}, {
				id: 'exclude',
				mode: 'Not any of'
			}];
			self.time_limit_days = [{
				id: 1,
				name: 'Mon'
			}, {
				id: 2,
				name: 'Tue'
			}, {
				id: 3,
				name: 'Wed'
			}, {
				id: 4,
				name: 'Thu'
			}, {
				id: 5,
				name: 'Fri'
			}, {
				id: 6,
				name: 'Sat'
			}, {
				id: 0,
				name: 'Sun'
			}];
			self.time_limit_hours = Array.from(Array(24).keys());
			self.fixed_modes = [{
				id: 'disable',
				mode: 'No special selection'
			}, {
				id: 'random',
				mode: 'Random from selection'
			}, {
				id: 'fixed',
				mode: 'Entire selection in order'
			}, {
				id: 'priority',
				mode: 'Order by performance'
			}, {
				id: 'original',
				mode: 'Order by original order/position in stream'
			}, {
				id: 'exclude',
				mode: 'Exclude selected content'
			}];
		}

    api.on('update-audience',function(e) {
      loadPostCategories()
      loadPostTags()
    })

		function X_loadPostCategories() {
		  var customer_id = self.parent.campaign && self.parent.campaign.customer_id
		                    || self.parent.parent.parent.campaign.customer_id;
		  api.service('audiences').find({ query: { customer_id: customer_id, $select:['name'],$sort:{name:1}, $limit:1000 } })
		  .then(categories => {
		    self.post_categories = categories.data.map(c => c.name)
        self.update()
	    })
	    .catch(console.error)
		}

		function loadPostCategories() {
		  var site_ids = self.site ? [self.site._id] : (self.sites ? self.sites.map( s => s._id ) : []);
console.log('hav site_ids',site_ids)
      api.service('aggregate').find({
        query:{
          database: 'trafex',
          service: 'posts',
          pipe: [
            {$match: {site: {$in: site_ids }}},
            {$unwind:"$categories"},
            {$group: {_id:"$categories"}}
          ]
        },
      })
			.then(data => {
				self.post_categories = data.map(c => c._id);
				self.update()
			})
			.catch(console.error)
		}

		function loadPostTags() {
		  var site_ids = self.sites.map( s => s._id );
console.log('hav site_ids',site_ids)
      api.service('aggregate').find({
        query:{
          database: 'trafex',
          service: 'posts',
          pipe: [
            {$match: {site: {$in: site_ids }}},
            {$unwind:"$tags"},
            {$group: {_id:"$tags"}},
            {$match: {_id:{$regex:'Akcija'}}}
          ]
        },
      })
			.then(data => {
				self.post_tags = data;
				self.update()
			})
			.catch(console.error)
		}

		function loadPosts() {
		  var site_ids = self.sites.map( s => s._id );
		  var sqry = {site: {$in: site_ids},status:self.post_filter}
		  if (self.segment.category!='all') sqry.categories = self.segment.category
		  if (self.segment.tag!='all') sqry.tags = self.segment.tag
		  if (self.segment.manual_query) {
		    console.log('have manual',self.segment.manual_query)
		    sqry = Object.assign(sqry,JSON.parse(self.segment.manual_query))
		  }
		  var query = {$or:[{_id:{$in:self.segment.selected}},sqry], $sort: { name: 1 }};
console.log('load posts',query)
			api.service('posts').find({ query })
				.then(data => {
					self.posts = data.data;
					renderPosts();
				})
				.catch(err => api.emit('toast', { type: 'danger', title: 'Error fetching posts', content: err.message }));
		}
		function renderPosts() {

			self.available_posts = [];
			self.selected_posts = [];

			for(let post of self.posts) {
				if(self.segment.selected.includes(post._id))
					self.selected_posts.push(post);
				else
					self.available_posts.push(post);
			}
			self.update();
		}

		this.setDefault = function(e) {
			self.parent.setDefaultSegment(e);
			e.preventUpdate = true;
		}.bind(this)
		this.removeSegment = function(e) {
			self.parent.removeSegment(e);
			e.preventUpdate = true;
		}.bind(this)
		this.toggleExpanded = function(e) {
			e.preventDefault();
			self.expanded = !self.expanded;

			if(self.expanded) {
				self.parent.expanded_segment = self.segment.profile_id;
				loadPostCategories();
				loadPostTags();
				loadPosts();
			}
		}.bind(this)
		this.setPinned = function(e) {
		  self.parent.setPinnedSegment(e);
		  e.preventUpdate = true;
		}.bind(this)
		this.setExclusive = function(e) {
			e.preventDefault();
		  self.segment.exclusive = self.refs.exclusive.checked;
		}.bind(this)
		this.setPinnedPosts = function(e) {
			e.preventDefault();
			self.segment.pinned_posts = self.refs.pinned_posts.value;
		}.bind(this)
		this.setMode = function(e) {
			e.preventDefault();
			self.segment.fixed_mode = self.refs.fixed_mode.value;
		}.bind(this)
		this.setGoalMode = function(e) {
			e.preventDefault();
			self.segment.goal_limit.mode = self.refs.goal_mode.value;
		}.bind(this)
		this.setGoalLimit = function(e) {
			e.preventDefault();
			self.segment.goal_limit.limit = self.refs.goal_limit.value;
		}.bind(this)
		this.setTimeLimitMode = function(e) {
			e.preventDefault();
			self.segment.time_limit.mode = self.refs.time_limit_mode.value;
		}.bind(this)
		this.toggleTimeLimit = function(day, hour) {
			return function(e) {
				e.preventDefault();
				let target_limit = self.time_limit_intervals[day];

				if(!target_limit)
					target_limit = self.time_limit_intervals[day] = {};
				if(!target_limit[hour]) {
					target_limit[hour] = true;
					self.segment.time_limit.intervals.push(String(day) + '-' + String(hour));
				} else {
					delete target_limit[hour];
					self.segment.time_limit.intervals.splice(self.segment.time_limit.intervals.indexOf(String(day) + '-' + String(hour)), 1);
				}
			}
		}.bind(this)
		this.setPostCategoryFilter = function(e) {
			self.segment.category = e.target.value;
			e.preventUpdate = true;
			loadPosts();
		}.bind(this)
		this.setPostTagFilter = function(e) {
			self.segment.tag = e.target.value;
			e.preventUpdate = true;
			loadPosts();
		}.bind(this)
		this.setPostStatusFilter = function(e) {
			self.post_filter = e.target.value;
			e.preventUpdate = true;
			loadPosts();
		}.bind(this)
		this.isPostStatusFilter = function(value) {
			return self.post_filter === value;
		}.bind(this)
		this.setManualQuery = function(e) {
			self.segment.manual_query = e.target.value;
			e.preventUpdate = true;
			loadPosts();
		}.bind(this)
		this.drag = function(e) {
			if(self.drop_location)
				self.drop_location.classList.remove('dragging');
			self.dragged_post = e.item.post;
			self.drop_location = null;
		}.bind(this)
		this.markDrop = function(e) {
			e.preventDefault();
			let target = e.target;
			let steps = 10;

			while(!target.classList.contains('drop-area') && steps > 0) {
				target = target.parentNode;
				steps--;
			}

			if(self.drop_location)
				self.drop_location.classList.remove('dragging');
			self.drop_location = target;

			target.classList.add('dragging');
		}.bind(this)
		this.drop = function(mode) {
			return function(e) {
				e.preventDefault();
				e.stopPropagation();
				let post = self.dragged_post;

				if(self.drop_location)
					self.drop_location.classList.remove('dragging');

				if(!self.segment.selected)
					self.segment.selected = [];

				if(mode === 'select') {
					if(!self.segment.selected.includes(post._id)) {
						self.segment.selected.push(post._id);
						self.available_posts.splice(self.available_posts.indexOf(post), 1);
						self.selected_posts.push(post);
					}
				} else if(mode === 'before') {

					self.selected_posts = self.selected_posts.filter(a => a._id != post._id);
					self.selected_posts.splice(self.selected_posts.indexOf(e.item.post || e.item), 0, post);

					self.segment.selected = self.segment.selected.filter(a => a != post._id);
					self.segment.selected.splice(self.segment.selected.indexOf(e.item.post && e.item.post._id || e.item._id), 0, post._id);

					self.available_posts = self.available_posts.filter(a => a._id != post._id);
				} else {
					if(self.segment.selected.includes(post._id)) {
						self.segment.selected.splice(self.segment.selected.indexOf(post._id), 1);
						self.selected_posts.splice(self.selected_posts.indexOf(post), 1);
						self.available_posts.push(post);
					}
				}
				self.update();
			}
		}.bind(this)
		this.exportPosts = function(e) {
			e.preventDefault();

			let dummy = document.createElement("input");
			document.body.appendChild(dummy);

			dummy.value = JSON.stringify(self.segment.selected);

			dummy.select();
			document.execCommand("copy");

			document.body.removeChild(dummy);
			api.emit('toast', { type: 'info', title: 'Posts exported' });
		}.bind(this)
		this.importPosts = function(e) {
			e.preventDefault();

			let code = prompt('Please enter the import code', '[]');

			try {

				let imported = JSON.parse(code);

				if(!Array.isArray(imported))
					return api.emit('toast', { type: 'danger', title: 'Error importing posts', content: 'The specified code is invalid!' });
				for(let post of imported)
					if(!self.posts.some(a => a._id == post))
						return api.emit('toast', { type: 'danger', title: 'Error importing posts', content: 'One or more posts do not exist!' });

				self.segment.selected = imported;
				renderPosts();
				api.emit('toast', { type: 'info', title: 'Posts imported' });
			} catch(err) {
				api.emit('toast', { type: 'danger', title: 'Error importing posts', content: err.message });
			}
		}.bind(this)
		this.save = function() {
			self.profile.filter = self.refs.filter.value;
			self.profile.iab_filter = self.refs.iab_filter.value;
		}.bind(this)

		self.on('mount', () => {
			self.segment.category = self.segment.category || self.profile.name;

		  var filters = []
		  if (self.profile.filter) filters.push(self.profile.filter)
		  if (self.profile.iab_filter) {
          let
            iab = (self.profile.iab_filter || '')
                  .replace(/:\d/gi,'')
                  .split(/\s+?/g)
                  .map(f => f.trim())
                  .reduce( (a,f) => {
                    if (f.substring(0,1)=='+') a.must.push(f.substring(1))
                    else if (f.substring(0,1)=='-') a.must_not.push(f.substring(1))
                    else if (f) a.should.push(f);
                    return a;
                  },{should:[],must:[],must_not:[]});

            fld = self.profile.bexType=='hot' ? 'hottags.tag' : 'profile.bex';

            if (iab.should.length>0) filters.push(fld+":("+iab.should.join(' OR ') + ')' )
            if (iab.must.length>0) filters.push(fld+":("+iab.must.join(' AND ') + ')' )
            if (iab.must_not.length>0) filters.push("NOT("+fld+":"+iab.must_not.join(' OR ') +')' )
		  }

		  self.userfilter = filters.length ? '&q=(' + filters.join(')AND(')  + ')' : ''
		  self.userfilter = self.userfilter.replaceAll('+','%2B');

			for(let interval of self.segment.time_limit.intervals) {
				let time_limit = interval.split('-');
				let limit_day = Number(time_limit[0]);
				let limit_hour = Number(time_limit[1]);
				let target_limit = self.time_limit_intervals[limit_day];

				if (!target_limit) target_limit = self.time_limit_intervals[limit_day] = {};

				target_limit[limit_hour] = true;
			}
		});
});
